var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReliability(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.384,
    height: 50.226,
    viewBox: "0 0 47.384 50.226",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_62761",
    "data-name": "Group 62761",
    transform: "translate(1.003 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107792",
    "data-name": "Path 107792",
    d: "M44.4,149.781H55.957s1.166,13,11.581,13c0,0,.037,6.924-.291,10.692-.333,3.826-3.277,21.309-22.215,24.385",
    transform: "translate(-22.161 -149.781)",
    fill: "none",
    stroke: "#00a6ef",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107793",
    "data-name": "Path 107793",
    d: "M56.858,149.781H45.3s-1.166,13-11.581,13c0,0-.035,6.924.291,10.692.333,3.826,3.279,21.309,22.215,24.385",
    transform: "translate(-33.718 -149.781)",
    fill: "none",
    stroke: "#00a6ef",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107796",
    "data-name": "Path 107796",
    d: "M43.827,165.334l6.762,5.066,8.925-12.129",
    transform: "translate(-27.869 -142.161)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReliability);
export default __webpack_public_path__ + "static/media/reliability.bee1a0530ec0a78cf846e60f2bbcccde.svg";
export { ForwardRef as ReactComponent };